import { border } from "@mui/system";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table, Button, Dropdown, Card, Form, Badge } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import "./MarketPlaceOrderView.css";
import moment from "moment";
import swal from "sweetalert";
import { serverInfo } from "../../../../../../../App";
import { useContext } from "react";

const MarketplaceOrderView = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const { id } = useParams();

  const [orderView, setOrderListView] = useState("");
  const [orderViewStatus, setOrderListViewStatus] = useState("");

  const getMarketPlaceData = () => {
    axios
      .get(`/api/admin/marketplace/order/product-list/view/${id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setOrderListView(res.data.orderListView);
          setOrderListViewStatus(res.data.orderListView.status);
        }
      });
  };

  useEffect(() => {
    getMarketPlaceData();
  }, []);

  const handleDeliveryStatus = (data) => {
    axios
      .post(
        `/api/admin/marketplace/order/product/status/${data}/${orderView.id}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          swal("Welcome", res.data.message, "success");
          getMarketPlaceData();
        }
      });
  };

  return (
    <div className="container">
      <Card className="cardMain">
        <Link to="/superstar-admin/marketplace-orderlist">
          <h4>
            <Badge bg="danger">
              <i className="fa-solid fa-chevron-left"> </i> Back
            </Badge>
          </h4>
        </Link>
        <Card.Header className="CardHeader">Order Details</Card.Header>
        <Card.Body>
          <div className="row" style={{ padding: "10px" }}>
            <div className="col-md-4">
              <h5>
                Payment Status :{" "}
                {orderView?.payment_status == 1 ? (
                  <Badge bg="success">Paid</Badge>
                ) : (
                  <Badge bg="danger">Unpaid</Badge>
                )}
              </h5>
            </div>
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <h5>Delivery Status</h5>
              {/* value = {orderView.status} */}
              <Form.Select
                aria-label="Default select example"
                onChange={(e) => handleDeliveryStatus(e.target.value)}
                value={orderView.status}
              >
                {/* {orderView?.status < 1 ? (
                  <option value="1">Ordered</option>
                ) : (
                  <option>Ordered</option>
                )}

                {orderView?.status >= 1 ? (
                  <option value="2">Received</option>
                ) : (
                  <option>Received</option>
                )}

                {orderView?.status == 2 ? (
                  <option value="3">Out for Delivery</option>
                ) : (
                  <option>Out for Delivery</option>
                )}

                {orderView?.status == 3 ? (
                  <option value="4">Delivered</option>
                ) : (
                  <option>Delivered</option>
                )} */}

                <option>--Select Status--</option>
                <option value="1">Ordered</option>
                <option value="2">Received</option>
                <option value="3">Out for Delivery</option>
                <option value="4">Delivered</option>
              </Form.Select>
            </div>
          </div>
          <hr />
          <div className="row" style={{ padding: "10px" }}>
            <div className="col-md-4">
              <img
                src={imageCdnUrl + orderView.star?.image}
                alt=""
                className="img-fluid"
                style={{
                  height: "150px",
                  width: "170px",
                  border: "3px solid #fcc106",
                  borderRadius: "50%",
                }}
              />
            </div>
            <div className="col-md-4">
              <h4 style={{ paddingLeft: "8px" }}>Star Info</h4>
              <p style={{ paddingLeft: "8px" }}>
                <b>Name : </b>
                {orderView.star?.first_name} {orderView.star?.last_name}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Phone No : </b>
                {orderView.star?.phone}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Email : </b>
                {orderView.star?.email}
              </p>
            </div>
            <div className="col-md-4">
              {/* <h5>Delivery Status</h5> */}
              {/* value = {orderView.status} */}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-4">
              <h4 style={{ paddingLeft: "8px" }}>User Info</h4>
              <p style={{ paddingLeft: "8px" }}>
                <b>Name : </b>
                {orderView.user?.first_name} {orderView.user?.last_name}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Phone No : </b>
                {orderView?.phone}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Email : </b>
                {orderView.user?.email}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Address : </b>
                {orderView?.area}, {orderView.city?.name}, <br />{" "}
                {orderView.state?.name},{orderView.country?.name}
              </p>
            </div>
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <h4>
                <b>Order : </b>#{orderView?.order_no}
              </h4>
              <p>
                <b>Order Status : </b>
                <Badge bg="secondary">
                  {orderView.status == 1
                    ? "Ordered"
                    : orderView.status == 2
                    ? "Received"
                    : orderView.status == 3
                    ? "Out for Delivery"
                    : "Delivered"}
                </Badge>
              </p>
              <p>
                <b>Order Date : </b>
                {moment(orderView?.created_at).format("LL")}{" "}
                {moment(orderView?.created_at).format("LT")}
              </p>
              <p>
                <b>Total amount : </b>
                ${orderView?.total_price}
              </p>
              <p>
                <b>Delivery Country : </b>
                {orderView?.deliverycharge?.country}
              </p>
              <p>
                <b>Delivery Company : </b>
                {orderView?.deliverycharge?.courier_company}
              </p>
            </div>
          </div>

          <hr />
          <div className="row" style={{ overflowX: "auto" }}>
            <Table
              className="table w-100"
              striped
              bordered
              hover
              variant="warning"
            >
              <thead className="table-info">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Product Name</th>
                  <th scope="col">Image</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Unit Price</th>
                  <th scope="col">Total Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td>{orderView.marketplace?.title}</td>
                  <td>
                    <img
                      src={imageCdnUrl + orderView.marketplace?.image}
                      alt=""
                      className="img-fluid"
                      style={{
                        height: "50px",
                        border: "3px solid #fcc106",
                        borderRadius: "10px",
                      }}
                    />
                  </td>
                  <td>{orderView?.items}</td>
                  <td>${orderView?.unit_price}</td>
                  <td>${orderView?.items * orderView?.unit_price}</td>
                </tr>
              </tbody>
            </Table>
          </div>

          <br />
          <div className="row">
            <div className="col-md-9"></div>
            <div className="col-md-3">
              <p>Sub Total : ${orderView?.items * orderView?.unit_price}</p>
              <p>Tax : ${orderView?.tax}</p>
              <p>Delivery Charge : ${orderView?.deliverycharge?.courier_charge}</p>
              <hr />
              <p>Grand Total : ${orderView?.total_price}</p>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default MarketplaceOrderView;
